import { InfoIcon } from 'lucide-react';
import React from 'react';

import { Tooltip } from '@/components/Tooltip';

export interface SettingSectionHeaderProps {
  /** Section title (large, bold) */
  title: string;
  /** Optional description text below title */
  description?: string;
  /** Optional tooltip text shown next to title */
  tooltip?: string;
  /** Additional className for wrapper */
  className?: string;
}

/**
 * Standardized settings section header with title, description, and optional tooltip
 *
 * Used across all settings pages for consistent typography and spacing
 *
 * @example
 * ```tsx
 * <SettingSectionHeader
 *   title="Account Settings"
 *   description="Manage your account preferences"
 *   tooltip="Additional help information"
 * />
 * ```
 */
export const SettingSectionHeader: React.FC<SettingSectionHeaderProps> = ({
  title,
  description,
  tooltip,
  className,
}) => {
  return (
    <div className={className}>
      <div className="flex items-center gap-2">
        <h2 className="text-lg font-bold">{title}</h2>
        {tooltip && (
          <Tooltip title={tooltip}>
            <InfoIcon className="text-chariot-text-secondary size-4" />
          </Tooltip>
        )}
      </div>
      {description && (
        <p className="text-chariot-text-secondary text-sm">{description}</p>
      )}
    </div>
  );
};
